module.exports = __webpack_public_path__ + "static/media/results_not_found.bd4e069a.jpg";